export const ONLINE_ROUND_SECONDS = 60;
export const ONLINE_SPIN_ENTRY_LOCK_SECONDS = 15;
export const ONLINE_SPIN_ENTRY_LOCK_START = ONLINE_ROUND_SECONDS - ONLINE_SPIN_ENTRY_LOCK_SECONDS;
export const ONLINE_AUTO_BET_LEAD_SECONDS = 5;
export const ONLINE_AUTO_BET_SUBMIT_START = Math.max(
  ONLINE_SPIN_ENTRY_LOCK_START - ONLINE_AUTO_BET_LEAD_SECONDS,
  0
);
